import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import MultiInput from 'modules/core/components/MultiInput'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { thresholdUnitsOptions } from 'modules/timeoff/components/TimeoffCompensation/utils/unitsOptions'
import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

interface ThresholdComponentProps {
  form: TimeoffCompensationForm
}

const Threshold = ({ form }: ThresholdComponentProps) => {
  return (
    <>
      {form.get('has_threshold_enabled').value && (
        <Box flexDirection="column" gap="s6">
          <MultiInput
            label={i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.threshold'
            )}
            description=""
          >
            <Box width="s140">
              <TextField
                value={form.get('threshold_capacity').value}
                onChange={(threshold_capacity) =>
                  form.setValues({ threshold_capacity: +threshold_capacity })
                }
                hideLabel
                type="number"
                mandatory={form.get('has_threshold_enabled').value}
                min={form.get('has_threshold_enabled').value ? 0 : undefined}
              />
            </Box>
            <Box width="s140">
              <SelectField
                value={form.get('threshold_units').value}
                options={thresholdUnitsOptions()}
                onChange={(selected) => form.setValues({ threshold_units: selected })}
                hideLabel
              />
            </Box>
          </MultiInput>
          <Text size="200">
            {i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.threshold_explanation'
            )}
          </Text>
        </Box>
      )}
    </>
  )
}

export default observer(Threshold)
